import React from 'react';
import { connect } from 'react-redux';
import { fnum } from '../../../utils/utils';
import { fetchPayments } from '../../../actions/reportActions';
import { fetchOrders } from '../../../actions/orderActions'
import FilterForm from './FilterForm';
import GroupsForm from './GroupsForm';
import moment from 'moment';

class Payments extends React.Component{

  state = {
    filter: {
      dateFrom: moment().subtract(1, "months").format('Y-MM-DD'),
      dateTo: moment().add(1, "months").format('Y-MM-DD'),
      month: [],
      quarter: [],
      year: [],
      seller: [],
      payer: [],
      order: [],
      srvc: [],
      account: [],
      project: [],
      payed: []
    },
    groups: []
  }

  componentWillMount(){
    this.props.fetchPayments();
    this.props.fetchOrders();
  }

  setFilters = (filter) => {
    this.setState({
      filter
    });
    localStorage.paymentsFilter = JSON.stringify(filter);
  }

  setGroups = (groups) => {
    this.setState({
      groups
    });
    localStorage.paymentsGroups = JSON.stringify(groups);
  }

  render() {
    const { payments, orders } = this.props;
    if(!payments.length){
      return(<div>Загрузка данных...</div>);
    }
    const { filter, groups } = this.state;
    const names = {
      date: 'Дата',
      month: 'Месяц',
      quarter: 'Квартал',
      year: 'Год',
      seller: 'Поставщик',
      payer: 'Плательщик',
      order: 'Заказ',
      srvc: 'Метод оплаты',
      payed: 'Оплачен',
      note: 'Заметка'
    };

    const rows = {};
    const options = {};
    const optionNames = [
      'date',
      'month',
      'quarter',
      'year',
      'seller',
      'payer',
      'order',
      'srvc',
      'payed',
      'account',
      'project',
      'note'
    ];

    const filtered = payments.filter((payment) => {
      for(let j = 0; j < optionNames.length; j++){
        options[optionNames[j]] = options[optionNames[j]] || {};
        options[optionNames[j]][payment[optionNames[j]]] = 1;
      }
      let inFilter = true;
      if(
        payment.date < filter.dateFrom || payment.date > filter.dateTo
      ){
        inFilter = false;
      }
      else if(
        filter.month.length &&
        (filter.month.indexOf(moment(payment.date).format('M')) === -1)
      ){
        inFilter = false;
      }
      else if(
        filter.quarter.length &&
        (filter.quarter.indexOf(moment(payment.date).format('Q')) === -1)
      ){
        inFilter = false;
      }
      else if(
        filter.year.length &&
        (filter.year.indexOf(payment.date.substr(0, 4)) === -1)
      ){
        inFilter = false;
      }
      else if(
        filter.seller.length &&
        (filter.seller.indexOf(payment.seller) === -1)
      ){
        inFilter = false;
      }
      else if(
        filter.payer.length &&
        (filter.payer.indexOf(payment.payer) === -1)
      ){
        inFilter = false;
      }
      else if(
        filter.order.length &&
        (filter.order.indexOf(""+payment.order) === -1)
      ){
        inFilter = false;
      }
      else if(
        filter.srvc.length &&
        (filter.srvc.indexOf(payment.srvc) === -1)
      ){
        inFilter = false;
      }
      else if(
        filter.payed.length &&
        (filter.payed.indexOf(payment.payed) === -1)
      ){
        inFilter = false;
      }
      else if(
        filter.account.length &&
        (filter.account.indexOf(payment.account) === -1)
      ){
        inFilter = false;
      }
      else if(
        filter.project.length &&
        (filter.project.indexOf(payment.project) === -1)
      ){
        inFilter = false;
      }
      return inFilter;
    });

    const sorted = filtered.sort((a, b) => {
      for(let i = 0; i < groups.length; i++){
        if(a[groups[i]] < b[groups[i]])
          return -1
        if(a[groups[i]] > b[groups[i]])
          return 1
      }
      return 0
    });

    let total = 0;
    for(let i = 0; i < sorted.length; i++){
      total += sorted[i].sum;
      rows[sorted[i][groups[0]]] = rows[sorted[i][groups[0]]] || {};
      rows[sorted[i][groups[0]]].sum = (rows[sorted[i][groups[0]]].sum || 0) + sorted[i].sum;
      if(groups[1]){
        rows[sorted[i][groups[0]]].subs = rows[sorted[i][groups[0]]].subs || {};
        const group1 = rows[sorted[i][groups[0]]].subs;
        group1[sorted[i][groups[1]]] = group1[sorted[i][groups[1]]] || {};
        group1[sorted[i][groups[1]]].sum = (group1[sorted[i][groups[1]]].sum || 0) + sorted[i].sum;
        if(groups[2]){
          group1[sorted[i][groups[1]]].subs = group1[sorted[i][groups[1]]].subs || {};
          const group2 = group1[sorted[i][groups[1]]].subs;
          group2[sorted[i][groups[2]]] = group2[sorted[i][groups[2]]] || {};
          group2[sorted[i][groups[2]]].sum = (group2[sorted[i][groups[2]]].sum || 0) + sorted[i].sum;
          if(groups[3]){
            group2[sorted[i][groups[2]]].subs = group2[sorted[i][groups[2]]].subs || {};
            const group3 = group2[sorted[i][groups[2]]].subs;
            group3[sorted[i][groups[3]]] = group3[sorted[i][groups[3]]] || {};
            group3[sorted[i][groups[3]]].sum = (group3[sorted[i][groups[3]]].sum || 0) + sorted[i].sum;
          }
        }
      }
    }

    const mappedRows = [];
    for(let val in rows){
      if(rows.hasOwnProperty(val)){
        mappedRows.push(
          <tr key={"tr" + val} className="pivot-level-0">
            <td>{val}</td>
            {groups[1] && <td></td>}
            {groups[2] && <td></td>}
            {groups[3] && <td></td>}
            <td className="text-right">{fnum(rows[val].sum)}</td>
          </tr>
        );
        if(groups[1]){
          for(let val1 in rows[val].subs){
            if(rows[val].subs.hasOwnProperty(val1)){
              mappedRows.push(
                <tr key={"tr1" + val + val1} className="pivot-level-1">
                  <td></td>
                  <td>{val1}</td>
                  {groups[2] && <td></td>}
                  {groups[3] && <td></td>}
                  <td className="text-right">{fnum(rows[val].subs[val1].sum)}</td>
                </tr>
              );
              if(groups[2]){
                for(let val2 in rows[val].subs[val1].subs){
                  if(rows[val].subs[val1].subs.hasOwnProperty(val2)){
                    mappedRows.push(
                      <tr key={"tr2" + val + val1 + val2} className="pivot-level-2">
                        <td></td>
                        <td></td>
                        <td>{val2}</td>
                        {groups[3] && <td></td>}
                        <td className="text-right">{fnum(rows[val].subs[val1].subs[val2].sum)}</td>
                      </tr>
                    );
                    if(groups[3]){
                      for(let val3 in rows[val].subs[val1].subs[val2].subs){
                        if(rows[val].subs[val1].subs[val2].subs.hasOwnProperty(val3)){
                          mappedRows.push(
                            <tr key={"tr3" + val + val1 + val2 + val3} className="pivot-level-3">
                              <td></td>
                              <td></td>
                              <td></td>
                              <td>{val3}</td>
                              <td className="text-right">{fnum(rows[val].subs[val1].subs[val2].subs[val3].sum)}</td>
                            </tr>
                          );
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    return (
      <div className="toPrint">
        <h1>Платежи</h1>
        <h3>Фильтры</h3>
        <FilterForm
          options={options}
          orders={orders}
          filter={filter}
          setFilters={this.setFilters}
        />
        <div className="hidden-print">
          <h3>Группировки</h3>
          <GroupsForm
            groups={groups}
            setGroups={this.setGroups}
            optionNames={optionNames}
            names={names}
          />
        </div>
        <h3>Данные</h3>
        <table className="table">
          <thead>
            <tr>
              <th id="siska">{names[groups[0]]}</th>
              {groups[1] && <th>{names[groups[1]]}</th>}
              {groups[2] && <th>{names[groups[2]]}</th>}
              {groups[3] && <th>{names[groups[3]]}</th>}
              <th className="text-right">Сумма</th>
            </tr>
          </thead>
          <tbody>
            {mappedRows}
          </tbody>
        </table>
        <h2 className="pull-right">Итого: {fnum(total)}</h2>
      </div>
    );
  }
}

function mapOrdersToProps(store){
  return {
    payments: store.reports.payments,
    orders: store.orders.data
  }
}

export default connect(mapOrdersToProps, { fetchPayments, fetchOrders })(Payments);



// WEBPACK FOOTER //
// ./src/components/reports/payments/Payments.js